import { Box, Button, Divider, IconButton, MenuItem, Pagination, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import AddIcon from '@mui/icons-material/Add';
import { usePopUpManageControllers } from './controller';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FormPopUpManageView from './form';
import TabPanelComponent from './components/tabPanel';
import { PopupModel } from '../../models/popup';
import { IMAGE_POPUP_ROOT_URL } from '../../constants/imageUrl';
import { convertDateStringToNormalString } from '../../utils/convertDateFormat';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../components/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import TabPanelActiveComponent from '../customer/components';
import { PopupTypeEnum } from '../../enums/popupTypeEnum';
import StatusChip from '../../components/StatusChip';

const PopUpManagementView = () => {
  const controller = usePopUpManageControllers();
  const { t } = useTranslation('global');

  return (
    <>
      {controller.openForm ? (
        <FormPopUpManageView
          onClose={controller.handleCloseForm}
          popupType={controller.tabPopupType}
          onFetchData={controller.handleGetData}
          selectedData={controller.selectedData}
          branchData={controller.merchantData}
          tagData={controller.tagPromotionData}
        />
      ) : (
        <>
          {!controller.loadingPage ? (
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                  {t('popup_page.Pop-up management')}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'end', mt: 4, mb: 2 }}>
              {controller.filterDataByType.length < 1 && (
                  <Button
                    variant="contained"
                    sx={{ textTransform: 'none', borderRadius: '10px', background: '#11A2F1' }}
                    onClick={controller.handleOpenForm}
                  >
                    <AddIcon />
                    &nbsp; {t('popup_page.Create pop-up')}
                  </Button>
                )}
              </Box>

              <Box sx={{ mb: 2, mt: 2, background: '#F4F6F8', borderBottom: 1, borderColor: 'divider' }} >
                <TabPanelComponent
                  value={controller.tabPopupType}
                  onChange={controller.handleTabPopupTypeChange}
                />
              </Box>
              <Box sx={{ mb: 2, mt: 2, background: '#F4F6F8', borderBottom: 1, borderColor: 'divider' }} >
               <TabPanelActiveComponent
                  value={controller.tabStatus}
                  onChange={controller.handleSetTabStatus}
                />
              </Box>
              <Box sx={{ mt: 2 }}>
                <TableContainer>
                  <Table>
                    <TableHead sx={{ background: '#F4F6F8' }}>
                      <TableRow>
                        <TableCell sx={{ borderBottom: 'none' }}> {t('popup_page.No')} </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}> {t('popup_page.Image')} </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}> {t('popup_page.Start Date')} </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}> {t('popup_page.End Date')} </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}> {t('popup_page.Popup type')} </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}> {t('popup_page.Status')} </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {controller.rows?.map((item: PopupModel, index: number) => {
                        const getPopupType = (item: PopupModel) =>
                          item?.productId
                            ? PopupTypeEnum.PRODUCT_DETAIL
                            : item?.promotionTagId
                            ? PopupTypeEnum.PROMOTION
                            : item?.subCategoryId
                            ? PopupTypeEnum.CATEGORY
                            : PopupTypeEnum.LANDING_PAGE;
                        return (
                          <TableRow key={index}>
                            <TableCell sx={{ borderBottom: 'none' }}> {controller.handleCountIndex(index)} </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>
                              <img alt="" key={item?.id} src={IMAGE_POPUP_ROOT_URL + item?.image?.url} style={{ width: 50, height: 50 }} />
                            </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}> {convertDateStringToNormalString(item?.startDate)} </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}> {convertDateStringToNormalString(item?.endDate)} </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}> {t(`popup_page.${getPopupType(item)}`)} </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}> <StatusChip status={item?.isActive} /> </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }} align="right">
                              <IconButton size="large" color="inherit" onClick={(e: any) => controller.onOpenMenu(e, item?.id)}>
                                <MoreHorizIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Divider sx={{ mt: 1, mb: 1 }} />
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                  <Pagination
                    color="primary"
                    onChange={controller.handlePageChange}
                    page={controller.currentPage}
                    count={controller.countPagination}
                  />
                </Box>
              </Box>
              <Popover
                open={Boolean(controller.openMenu)}
                anchorEl={controller.openMenu}
                onClose={controller.onCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                  sx: { p: 1, width: 140, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 }},
                }}
              >
                <MenuItem onClick={controller.handleClickEditButton}>
                  <EditIcon />
                  &nbsp;&nbsp;
                  {t('popup_page.Edit')}
                </MenuItem>

                <MenuItem sx={{ color: 'error.main' }} onClick={controller.handleClickDeleteButton}>
                  <DeleteIcon />
                  &nbsp;&nbsp;
                  {t('popup_page.Delete')}
                </MenuItem>
              </Popover>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <LoadingAnimatedIcon />
            </Box>
          )}
          <Box>
            <ConfirmDialog
              open={controller.openDeleteDialog}
              title={t('validatr_promotion.Do you want to delete data')}
              loading={controller.loadingDelete}
              onCancel={() => controller.handleSetOpenDeleteDialog(false)}
              onConfirm={() => controller.handleDeleteData()}
            />
          </Box>
        </>
      )}
    </>
  );
};
export default PopUpManagementView;
